import React from "react";
import { Controller } from "react-hook-form";
import { Box, FormHelperText, FormLabel } from "@material-ui/core";
import classnames from "classnames";

import { FieldToggle } from "../../../../components/field-toggle/field-toggle.component";

import { useFieldsStyles, SubTitle } from "../../../fields.styles";

import { RichTextInput } from "../rich-text-input/rich-text-input.component";

import { RichTextFieldProps } from "./rich-text-field.props";

export const RichTextField = (props: RichTextFieldProps) => {
  const { withAdd = false } = props;

  const commonClasses = useFieldsStyles();

  const hasError = !!props.form.formState.errors[props.name];
  const errorMessage = props.form.formState.errors[props.name]?.message;
  const canEdit = Boolean(props.userPermissions?.canEdit) || Boolean(props.noAuthRequired);

  const wrapperClasses = classnames({
    [commonClasses.fieldWrapper]: true,
  });

  return (
    <Controller
      control={props.form.control}
      name={`${props.name}` as const}
      render={(renderProps) => (
        <div className={wrapperClasses}>
          <Box display="flex" justifyContent="space-between">
            <FormLabel component="h2" error={hasError} required={props.required}>
              {props.label}
            </FormLabel>
            <SubTitle showIf={!!props.subTitle}>{props.subTitle}</SubTitle>
          </Box>

          <FieldToggle
            addButtonText={props.addButtonText}
            canEdit={canEdit}
            name={props.name}
            openByDefault={String(renderProps.field.value) !== ""}
            setValue={props.form.setValue}
            use={withAdd}
          >
            <RichTextInput
              {...{ ...renderProps.field, ref: undefined }}
              disabled={props.disabled || !canEdit}
              editorRef={renderProps.field.ref}
              error={hasError}
              toolbar={props.toolbar}
            />
          </FieldToggle>
          {hasError && <FormHelperText error={hasError}>{errorMessage}</FormHelperText>}
        </div>
      )}
    />
  );
};
